import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, concatMap, map, startWith, switchMap, } from 'rxjs/operators';
import { of } from 'rxjs';
import { DashboardActions } from './dashboard.actions';
import { DashboardService } from '../../api-services/dashboard/dashboard.service';
import { AppActions } from '../app/app.actions';

@Injectable()
export class DashboardEffects {
  private actions$ = inject(Actions);

  constructor(private dashboardService: DashboardService) { }

  loadConnCounter$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(DashboardActions.loadConnCounter),
      concatMap((action) =>
        this.dashboardService.getConnCounter(action.dealerId).pipe(
          switchMap((data) => [
            DashboardActions.loadConnCounterSuccess({ data }),
            AppActions.setLoading({ loading: false }),
          ]),
          catchError((error) =>
            of(AppActions.setError({ error }))
          ),
          startWith(AppActions.setLoading({ loading: true }))
        )
      )
    );
  });

  loadDashboardEquipments$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(DashboardActions.loadDashboardEquipments),
      switchMap((action) =>
        this.dashboardService
          .getEquipments(action.queryParams, action.page)
          .pipe(
            switchMap((data) => [
              DashboardActions.loadDashboardEquipmentsSuccess({ data }),
              AppActions.setLoading({ loading: false })
            ]),
            catchError((error) =>
              of(AppActions.setError({ error }))
            ),
            startWith(AppActions.setLoading({ loading: true }))
          )
      )
    );
  });

}
